<template>
  <nav class="top-navbar d-flex flex-row align-items-center p-3 px-3">
    <div class="mx-1 mr-5">
      <i class="fas fa-bars" @click="sideBarToggle"></i>
    </div>
    <div class="my-0 mr-auto">
      <img :src="'/static/icons/BaanRueJai.svg'" class="logo" />
    </div>
    <div class="nav nav-pills my-2">
      <!-- <a href="" class="p-2">
        <div class="noti"></div>
        <img :src="'/static/icons/Notification.png'" class="icon">
      </a> -->
      <a class="p-3 profile row mx-0">
        <!-- <div class="col-3">
          <div class="profile-icon"/>
        </div> -->
        <div class="offset-3 col-6 h2">{{ adminName }}</div>
        <div class="col-3 py-1">
          <!-- <i class="fas fa-angle-down"></i> -->
          <button class="btn btn-sm btn btn-secondary" @click="logout()">
            Logout
          </button>
        </div>
      </a>
    </div>
  </nav>
</template>

<script>
import { Auth, unsetCookie } from "@/lib/cookie";
export default {
  data() {
    return {
      sideBar: true,
      adminName: localStorage.getItem("adminName")
    };
  },
  methods: {
    sideBarToggle() {
      this.$store.state.sideBar = !this.$store.state.sideBar;
      // this.$store.commit('sideBarToggle');
    },
    logout() {
      localStorage.removeItem("adminName");
      localStorage.removeItem("adminRole");
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
      unsetCookie(Auth.AccessToken);
      unsetCookie(Auth.RefreshToken);
      this.$router.push({ name: "Login" });
    }
  }
};
</script>

<style scoped>
.top-navbar {
  height: 65px;
  width: 100%;
  padding: 10px;
  border-bottom: solid 2px #e0e0e0;
  background-color: #fff;
}
.logo {
  width: 70px;
  height: 32px;
}
.profile-icon {
  border-radius: 50%;
  height: 32px;
  width: 32px;
  background-color: #e0e0e0;
  float: none;
  color: #fff;
}
.icon {
  height: 24px;
  width: 24px;
  margin: 10px;
  cursor: pointer;
}
.noti {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: red;
  position: absolute;
  margin-left: 25px;
  margin-top: 5px;
}
.profile {
  border-left: solid 1px #e0e0e0;
  width: 240px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/layout/TopNavBar.vue